import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionPortal } from '@features/referentiel/models/action-portal.model';
import { AdminConfig } from '@features/referentiel/config/admin.config';
import { AppSourceEnum } from 'pu-core-library';

@Injectable({
  providedIn: 'root',
})
export class ActionProtalService {
  constructor(private httpClient: HttpClient) {}

  getActionPortals(): Observable<ActionPortal[]> {
    return this.httpClient.get<ActionPortal[]>(
      `${AdminConfig.getActionsListUrl}/${AppSourceEnum.POF}`,
    );
  }
}
